<template>
  <div>
    <!-- <button @click="download">下载</button> -->
    <!-- <a href="https://backstageweb.datastory.com.cn/appupdate/download?id=108">下载</a> -->
    <a href="http://10.6.9.110:9091/file/down.plist">下载</a>
  </div>
</template>

<script>
export default {
  methods: {}
};
</script>

<style lang="less" scoped>
a {
  position: absolute;
  top: 50px;
  left: 50%;
  transform: translateX(-50%);
}
</style>



// WEBPACK FOOTER //
// src/pages/appdownload/index.vue